/* eslint-disable react/prop-types */
import React from 'react';
import glamorous from 'glamorous';
import Advert from '../../../shared/library/advert';
import * as AD_THEMES from '../../../shared/library/advert/themes';
// import Companies from '../components/cards/companies';
import SignUpPrivateStackshare from '../../../shared/library/advert/sign-up-private-stackshare';
import {AD_IMPRESSION} from '../../../shared/constants/analytics';

const AdContainer = glamorous.div({
  width: 260,
  marginLeft: 20
});

// const NAV_BAR_HEIGHT = 90;
// const TOOL_CARD_STICKY_HEIGHT = 72;
// const AD_STICKY_POSITION = NAV_BAR_HEIGHT + TOOL_CARD_STICKY_HEIGHT + 18;

const Advertisement = ({
  stackup,
  slug,
  contentGroup,
  privateMode,
  adLayer,
  adCategory,
  adFunction
}) => {
  return (
    <AdContainer>
      <div
        style={{
          position: 'sticky',
          top: '34%'
        }}
      >
        <Advert
          placement="stackup-sticky"
          objectType="Stackup"
          objectId={slug}
          contentGroupPage={contentGroup}
          requestPath={stackup.path}
          layer={adLayer}
          category={adCategory}
          primaryFunction={adFunction}
          maxWidth={260}
          theme={AD_THEMES.COLUMN}
          impressionType={AD_IMPRESSION}
          // triggerAdShownOnMount={false}
        />
        {/* {!privateMode && <Companies />} */}
        {!privateMode && (
          <SignUpPrivateStackshare title="Manage your open source components, licenses, and vulnerabilities" />
        )}
      </div>
    </AdContainer>
  );
};

export default Advertisement;
